import { FormTemplate } from '../schema';
import { GENERAL_INTAKE_TEMPLATE } from './general-intake';
import { I130_INTAKE_TEMPLATE } from './i130-intake';

// Export all base templates
export const BASE_TEMPLATES: FormTemplate[] = [
  GENERAL_INTAKE_TEMPLATE,
  I130_INTAKE_TEMPLATE,
];

// Export individual templates for direct import
export { GENERAL_INTAKE_TEMPLATE, I130_INTAKE_TEMPLATE };

// Helper to find template by ID
export function getTemplateById(id: string): FormTemplate | undefined {
  return BASE_TEMPLATES.find(t => t.id === id);
}

// Helper to get templates by category
export function getTemplatesByCategory(category: FormTemplate['category']): FormTemplate[] {
  return BASE_TEMPLATES.filter(t => t.category === category);
}

// Helper to get templates by visa type
export function getTemplatesByVisaType(visaType: string): FormTemplate[] {
  return BASE_TEMPLATES.filter(t => t.visaType === visaType);
}
